import React, { SFC } from "react";
import { HelpItem, HelpCategory } from "./types";

export interface Props {
  onChange: (item: HelpItem) => void;
  helpCategories: HelpCategory[];
  activeItem?: HelpItem;
}

export const HelpMenu: SFC<Props> = ({ onChange, helpCategories, activeItem }) => {
  return (
    <div id="helpmenu">
      <ul>
        {helpCategories.map((category) => {
          return (
            <React.Fragment key={category.title}>
              <li className="cat">{category.title}</li>
              {category.items.map((item) => {
                return (
                  <li
                    key={item.title}
                    onClick={() => onChange(item)}
                    className={`item ${activeItem === item ? "active" : ""}`}
                  >
                    {item.title}
                  </li>
                );
              })}
            </React.Fragment>
          );
        })}
      </ul>
    </div>
  );
};

HelpMenu.displayName = "HelpMenu";
